import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import StepToShowComponent from "../../components/Step";
import { PersonalProvider } from "./PersonalContext";
import { SpaceBox } from "../../components/Space";
import PaymentErrorModalComponent from "../../components/PaymentErrorModal";
import { STEPS } from "../../data/personal";
import OrderService from "../../service/order";
import MoneyLogo1 from "../../images/money-1.svg";
import MoneyLogo2 from "../../images/money-2.svg";
import MoneyLogo3 from "../../images/money-3.svg";
import DecoratedGraphic from "../../images/graphic.png";
import PersonalStep1 from "./Step1";
import PersonalStep2 from "./Step2";
import PersonalStep3 from "./Step3";
import PersonalStep4 from "./Step4";
import PersonalStep5 from "./Step5";
import PersonalStep6 from "./Step6";
import crypter from "../../utils/crypter";
import { CookieUtils, Alert, IdentityUtils } from "../../utils";
import ConsentPage from "./consent";
import moment from "moment";

class PersonalPage extends Component {
  state = {
    showErroModal: false,
    errorTitle: "Payment is cancelled.",
    errorMessage: "Your payment session has expired, please return to merchant page and attempt payment again.",
    steps: STEPS,
    page: 0,

    step1: {
      counter: 1,
      planList: [
        {
          id: 1,
          packageCode: "PA101",
          title: "ทุนประกัน (แบบที่ 1)",
          logo: <img src={MoneyLogo1} width="40px" height="40px" alt="Logo1" />,
          insured: 300000,
          price: 1580.0,
          stamp: 20.0,
          vat: 0.0,
          total: 1600.0,
          medicalExpense: 15000.0,
        },
        {
          id: 2,
          packageCode: "PA201",
          title: "ทุนประกัน (แบบที่ 2)",
          logo: <img src={MoneyLogo2} width="40px" height="40px" alt="Logo3" />,
          insured: 500000,
          price: 2080.0,
          stamp: 20.0,
          vat: 0.0,
          total: 2100.0,
          medicalExpense: 25000.0,
        },
        {
          id: 3,
          packageCode: "PA301",
          title: "ทุนประกัน (แบบที่ 3)",
          logo: <img src={MoneyLogo3} width="40px" height="40px" alt="Logo4" />,
          insured: 1000000,
          price: 2980.0,
          stamp: 20.0,
          vat: 0.0,
          total: 3000.0,
          medicalExpense: 50000.0,
        },
      ],
      selectedPlan: "",
      acceptInsurance: false,
      acceptHealthCheck: false,
      onChangeModel: (object) => this.changeModelStep1(object),
      onUpdatePlan: (object) => this.changePlanStep1(object),
    },
    step2: {
      sIDNo: "",
      sSex: "",
      sInitNameTH: "",
      sFirstNameTH: "",
      sLastNameTH: "",
      BuyerInitNameTH: "",
      BuyerFirstNameTH: "",
      BuyerLastNameTH: "",
      sBirthDate: "",
      sOccupation: "",
      sMobile: "",
      sEmail: "",
      sStart_date: "",
      sEnd_date: "",
      sNo: "",
      sMoo: "",
      sSoi: "",
      sRoad: "",
      sProvince: "",
      sDistrict: "",
      sCity: "",
      sZipcode: "",
      sBuilding: "",
      Question1: "",
      Question2: "",
      Question3: "",
      Question4: "",
      Question5: "",
      Answer1_1: "",
      Answer1_2: "",
      Answer2: "",
      Answer3: "",
      Answer4: "",
      Answer5: "",
      benefits: [{ sInit: "", sFirstName: "", sLastName: "", sRelation: "" }],
      onChangeModel: (object) => this.changeModelStep2Insurance(object),
      onChangeAddressOther: (object) => this.changeModelStep2AddressOther(object),
      onChangeModelProvinces: (object) => this.changeModelProvinces(object),
      onChangeDateModel: (date) => this.changeDateModel(date),
      onChangeBenefit: (object) => this.changeModelStep2Benefit(object),
      onNavigate: (object) => this.onNavigate(object),
      onAddBenefit: (key) => this.onHandleBenefit("Add"),
      onRemoveBenefit: (key) => this.onHandleBenefit("Remove"),
      sAssuranceFor: "",
      sAssuranceRelation: "",
    },
    step3: {
      recieveEmail: "",
      recievePost: "",
      confirmInsurance: "",
      taxDeduction: 1,
      taxReciept: "assured", // assured or legal_person
      recieverID: "",
      reciever_sInit: "",
      recieverCompany: "",
      recieverCompanyNo: "",
      recieverCompanyPhone: "",
      recieverPhone: "",
      recieverEmail: "",
      sNo: "",
      sMoo: "",
      sSoi: "",
      sRoad: "",
      sProvince: "",
      sDistrict: "",
      sCity: "",
      sZipcode: "",
      onChangeModelProvinces: (object) => this.changeRecieverProvinces(object),
      onChangeModel: (object) => this.changeModelStep3Insurance(object),
      onNavigate: (object) => this.onNavigate(object),
    },
    step4: {
      paymentModel: {},
    },
    step5: {
      onNavigate: (object) => this.onNavigate(object),
    },
    step6: {
      cName: "",
      cLastName: "",
      cMobile: "",
      cReason: "",
      cEmail: "",
      cDetail: "",
      cDate: "",
      cTime: "",
      onChangeModel: (object) => this.changeModelStep6(object),
      onNavigate: (object) => this.onNavigate(object),
    },
  };

  constructor(props) {
    super(props);
    this.initPage();
  }

  initPage() {
    let stateBack = localStorage.getItem("states_person");
    let paymentResponse = CookieUtils.getCookie("pay_result_person");
    if (paymentResponse && stateBack) {
      //decode
      if (window && window.decodeURIComponent) {
        paymentResponse = window.decodeURIComponent(paymentResponse);
        stateBack = window.decodeURIComponent(stateBack);
      }
      paymentResponse = crypter.decode(paymentResponse);
      stateBack = crypter.decode(stateBack);

      //Case Error
      const { payment_result } = paymentResponse;
      const isSuccess = payment_result.success;
      this.state.page = isSuccess ? 5 : 4;
      let { step1, step2, step3, step4 } = this.state;
      step1 = { ...step1, ...stateBack.step1 };
      step2 = { ...step2, ...stateBack.step2 };
      step3 = { ...step3, ...stateBack.step3 };
      step4 = { ...step4, ...stateBack.step4 };

      this.state = {
        ...this.state,
        step1,
        step2,
        step3,
        step4,
        step5: {
          ...paymentResponse,
        },
      };

      if (!isSuccess) {
        this.state.showErroModal = true;
      }
      localStorage.setItem("states_person", "");
      CookieUtils.setCookie("states_person", "");
    }
  }

  onShowLoading() {
    this.setState({ ...this.state, loading: true });
  }

  onHideLoading() {
    this.setState({ ...this.state, loading: false });
  }

  onHandleBenefit(type) {
    const { step2 } = this.state;
    const { benefits } = step2 || {};
    if (type === "Add") {
      benefits[1] = {
        sInit: "",
        sFirstName: "",
        sLastName: "",
        sRelation: "",
      };
      step2.benefits = benefits;
      this.setState({ ...this.state, step2 });
    } else if (type === "Remove") {
      step2.benefits = [benefits[0]];
      this.setState({ ...this.state, step2 });
    }
  }

  onNavigate = (page) => {
    if (page === 0) {
      // this.props.history.replace("/");
    }

    if (page === 3) {
      const { step2 } = this.state;
      const { sEmail, Question1, Question2, Question3, Question4, Question5, Answer1_2 } = step2;
      if (
        (Question1 === true && Answer1_2.label === "ตั้งแต่ 8,000,000 บาท ขึ้นไป") ||
        Question2 === true ||
        Question3 === true ||
        Question4 === true ||
        Question5 === true
      ) {
        if (Question2) {
          step2.Answer2 = Question2;
          this.setState({ ...this.state, step2 });
        }

        const handleClickClose = () => {
          this.setState({ ...this.state, page: 2 }, () => window.scrollTo(0, 0));
          Alert.hideLoading();
        };

        Alert.alertMessage(
          "กรุณาติดต่อเจ้าหน้าที่",
          "อาชีพที่ระบุเป็นอาชีพที่ประกันไม่คุ้มครอง",
          "warning",
          "true",
          "ติดต่อเจ้าหน้าที่",
          "true",
          "ยกเลิก"
        ).then((res) => {
          if (res === "option1") {
            this.setState({ ...this.state, page: 6 }, () => window.scrollTo(0, 0));
          }
        });
        return true;
      }
      if (!this._validForm()) {
        return false;
      }
      if (!this._validEmail(sEmail)) {
        return false;
      }
    } else if (page === 4) {
      const { step3 } = this.state;
      const { recieverEmail } = step3;
      if (recieverEmail && !this._validEmail(recieverEmail)) {
        return false;
      }
      this._onVerifyOrder();
      return;
    }
    this.setState({ ...this.state, page }, () => window.scrollTo(0, 0));
  };

  //UI Action step1
  changeModelStep1 = ({ name, value }) => {
    const { step1 } = this.state;
    step1[name] = value;
    this.setState({ ...this.state, step1 });
  };

  changePlanStep1 = (planList) => {
    const { step1 } = this.state;
    step1.planList = planList;
    this.setState({ ...this.state, step1 });
  };

  changeModelStep2Insurance = ({ name, value }) => {
    const { step2 } = this.state;
    step2[name] = value;
    this.setState({ ...this.state, step2 });
  };

  changeModelStep2AddressOther = ({ name, value }) => {
    const { step2 } = this.state;
    step2[name] = value;
    this.setState({ ...this.state, step2 });
  };

  changeModelProvinces = (addressChange) => {
    const { step2 } = this.state;

    const step2Change = {
      ...step2,
      ...addressChange,
    };
    this.setState({ ...this.state, step2: step2Change });
  };

  changeRecieverProvinces = (addressChange) => {
    const { step3 } = this.state;

    const step3Change = {
      ...step3,
      ...addressChange,
    };
    this.setState({ ...this.state, step3: step3Change });
  };

  changeDateModel = (date) => {
    const { step2 } = this.state;
    step2.sStart_date = date;
    step2.sEnd_date = moment.utc(date).add(1, "years");
    this.setState({ ...this.state, step2 });
  };

  changeModelStep2Benefit = ({ key, name, value }) => {
    const { step2 } = this.state;
    const { benefits } = step2 || {};
    benefits[key][name] = value;
    this.setState({ ...this.state, step2 });
  };

  changeModelStep3Insurance = ({ name, value }) => {
    const { step3 } = this.state;
    step3[name] = value;
    this.setState({ ...this.state, step3 });
  };

  changeModelStep6 = ({ name, value }) => {
    const { step6 } = this.state;
    step6[name] = value;
    this.setState({ ...this.state, step6 });
  };

  checkDisbledNextButton() {
    const { page } = this.state;
    if (page === 1) {
      const { step1 } = this.state;

      const { selectedPlan, acceptInsurance, acceptHealthCheck } = step1 || {};
      if (!selectedPlan || !acceptInsurance || !acceptHealthCheck) {
        return true;
      } else {
        return false;
      }
    } else if (page === 2) {
      const { step2 } = this.state;
      const {
        sAssuranceFor,
        sAssuranceRelation,
        sIDNo,
        sSex,
        BuyerInitNameTH,
        BuyerFirstNameTH,
        BuyerLastNameTH,
        sInitNameTH,
        sFirstNameTH,
        sLastNameTH,
        sBirthDate,
        sOccupation,
        sMobile,
        sEmail,
        sStart_date,
        sEnd_date,
        sNo,
        sProvince,
        sDistrict,
        sCity,
        sZipcode,
        benefits,
        Question1,
        Question2,
        Question3,
        Question4,
        Question5,
        Answer1_1,
        Answer1_2,
        Answer2,
        Answer3,
        Answer4,
        Answer5,
      } = step2 || {};
      if (
        !sAssuranceFor ||
        !sIDNo ||
        !sSex ||
        !sInitNameTH ||
        !sFirstNameTH ||
        !sLastNameTH ||
        !sBirthDate ||
        !sOccupation ||
        !sMobile ||
        !sEmail ||
        !sStart_date ||
        !sEnd_date ||
        !sNo ||
        !sProvince ||
        !sDistrict ||
        !sCity ||
        !sZipcode
      ) {
        return true;
      }
      if (sAssuranceFor === "other") {
        if (!sAssuranceRelation || !BuyerInitNameTH || !BuyerFirstNameTH || !BuyerLastNameTH) {
          return true;
        }
      }
      for (let i = 0; i < benefits.length; i++) {
        if (!benefits[i].sInit || !benefits[i].sFirstName || !benefits[i].sLastName || !benefits[i].sRelation) {
          return true;
        }
      }
      if (Question1) {
        if (!Answer1_1 || !Answer1_2) {
          return true;
        }
      }
      if (Question3) {
        if (!Answer3) {
          return true;
        }
      }
      if (Question4) {
        if (!Answer4) {
          return true;
        }
      }
      if (Question5) {
        if (!Answer5) {
          return true;
        }
      }
    } else if (page === 3) {
      const { step3 } = this.state;
      const {
        recieveEmail,
        recievePost,
        confirmInsurance,
        taxDeduction,
        taxReciept,
        recieverID,
        reciever_sInit,
        recieverCompany,
        recieverCompanyNo,
        sNo,
        sProvince,
        sDistrict,
        sCity,
        sZipcode,
      } = step3;
      if (taxDeduction && !taxReciept) {
        return true;
      }
      if (taxReciept === "legal_person") {
        if (
          !recieverID ||
          !reciever_sInit ||
          !recieverCompany ||
          !recieverCompanyNo ||
          !sNo ||
          !sProvince ||
          !sDistrict ||
          !sCity ||
          !sZipcode
        ) {
          return true;
        }
      }
      if (!confirmInsurance) {
        return true;
      }
      // if (!recieveEmail && !recievePost) {
      //   return true;
      // } else {
      //   return false;
      // }
    } else if (page === 6) {
      const { step6 } = this.state;
      const { cName, cLastName, cMobile, cEmail, cDetail, cDate, cTime } = step6;
      if (!cName || !cLastName || !cMobile || !cEmail || !cDetail || !cDate || !cTime) {
        return true;
      } else {
        return false;
      }
    }
  }

  _validForm() {
    const { step2 } = this.state;
    const { sIDNo } = step2;

    if (!IdentityUtils.validateIdentity(sIDNo)) {
      return false;
    } else {
      return true;
    }
  }

  _validEmail(sEmail) {
    let check = true;

    if (!IdentityUtils.validateEmail(sEmail)) {
      check = false;
    }
    return check;
  }

  _onVerifyOrder() {
    const { step1, step2, step3 } = this.state;
    const { benefitType, benefits, legalBenefit, bankBenefit, companyBenefit, sStart_date, sEnd_date } = step2;
    const {
      sInitNameTH,
      sFirstNameTH,
      sLastNameTH,
      sIDNo,
      sSex,
      sEmail,
      sMobile,
      sBuilding,
      sBirthDate,
      sNo,
      sMoo,
      sSoi,
      sRoad,
      sProvince,
      sDistrict,
      sCity,
      sZipcode,
    } = step2;
    const { sNoOther, sMooOther, sSoiOther, sRoadOther, sProvinceOther, sDistrictOther, sCityOther, sZipcodeOther } =
      step2;

    const { recieveEmail = false, recievePost = false } = step3;
    const planDetail = step1.planList.filter((plan) => plan.id === step1.selectedPlan)[0] || {};

    let benefit = {};
    benefits.map((be, index) => {
      const seq = index + 1;
      benefit[`objBeneficiary${seq}`] = {
        sBeneficiarySeq: seq,
        sInit: be.sInit ? be.sInit.label : "",
        sFirstName: be.sFirstName ? be.sFirstName : "",
        sLastName: be.sLastName ? be.sLastName : "",
        sRelationID: be.sRelation ? be.sRelation.value : "",
        sRelation: be.sRelation ? be.sRelation.label : "",
      };
    });

    const objRequest = {
      objMaster: {
        sProductCode: "MTI06113",
        sPackageCode: planDetail.packageCode,
        planName: `ประกันภัยอุบัติเหตุสำหรับคุณ แผนที่ ${step1.selectedPlan} (${planDetail.packageCode})`, //planDetail.title,
        sPackagePremium: planDetail.price,
        sTotalPremium: planDetail.total,
        sStamp: planDetail.stamp,
        sVat: planDetail.vat,
        sBKOrderNo: CookieUtils.getCookie("app_bk_no"),
        sFromDate: moment(sStart_date).format("YYYY/MM/DD"),
        sToDate: moment(sEnd_date).format("YYYY/MM/DD"),

        sCountriesEN: "THAILAND", // destination country
        sSendDocBy: sEmail, // user's email
        sContactMT: sMobile, // user's phone no.
        sDeliveryTo: "",
        // recieveEmail && recievePost
        //   ? "Both"
        //   : recieveEmail
        //   ? "Email"
        //   : "POST", // deliveryTo
        lstObjOptional: [],
        // lstObjOptional: [{
        //   sOptionalCode: 'TRV',//planDetail.packageCode,
        //   sOptionalDesc: planDetail.name,
        //   sOptionalPremium: planDetail.total
        // }]
      },
      lstObjApplicantPerson: [
        {
          sApplicantSeq: 1,
          sType: "A",
          sPersonType: "P",
          sInitNameTH: sInitNameTH.label,
          sFirstNameTH: sFirstNameTH,
          sLastNameTH: sLastNameTH,

          sInitNameEN: "sInitNameEN",
          sFirstNameEN: "sFirstNameEN",
          sLastNameEN: "sLastNameEN",

          sIDNo: sIDNo ? sIDNo.replace(/-/g, "") : "",
          sIDType: "ID card",
          sSex: sSex,

          // sOccupationID: i.sOccupation.value,
          // sOccupation: i.sOccupation.label,
          sEmail: sEmail,

          sRDConsent: "",
          sNationality: "THA",
          sBirthDate: moment(sBirthDate).format("YYYY/MM/DD"),
          objApplicantAddress: {
            sType: "A",
            sNo: sNo,
            sBuilding: sBuilding,
            sVillage: sBuilding,
            sMoo: sMoo,
            sSoi: sSoi,
            sRoad: sRoad,
            sProvince: sProvince.label,
            sCity: sDistrict.label,
            sDistrict: sCity.label,
            sZipcode: sZipcode,
            sZipcode: "ไทย",
          },
          ...benefit,
        },
      ],
      objStep: {
        step1,
        step2,
        step3,
      },
    };

    Alert.showLoading();
    OrderService.orderVerify(objRequest)
      .then((res) => {
        Alert.hideLoading();
        if (res.info.bSuccess && res.hash) {
          const { step4 } = this.state;
          step4.paymentModel = res.hash;
          this.setState({ ...this.state, page: 4, step4 }, () => window.scrollTo(0, 0));
        } else if (!res.info.bSuccess) {
          console.log("Not completed:", res.info.lstObjResultKey[0].resultDesc.sDescTH);
          if (res.info.lstObjResultKey[0].resultDesc.sMTICode.includes("E")) {
            Alert.alertMessage(
              "กรุณากรอกข้อมูลให้ถูกต้อง",
              "ขออภัยค่ะ คุณสมบัติของท่านไม่เป็นไปตามเงื่อนไขการรับประกันภัย กรุณาติดต่อเจ้าหน้าที่ที่เบอร์ 1484 หรือฝากข้อมูลให้เจ้าหน้าที่ติดต่อกลับ",
              "warning",
              "true",
              "ติดต่อเจ้าหน้าที่",
              "true",
              "ยกเลิก",
            )
            .then(res => {
              if (res === "option1") {
                this.onNavigate(6);
              }
            });
          } else {
            Alert.alertWithTitle("กรุณาทำรายการใหม่อีกครั้ง", res.info.lstObjResultKey[0].resultDesc.sDescTH, "warning");
          }
        }
      })
      .catch((err) => {
        Alert.hideLoading();
      });
  }

  render() {
    const { showErroModal, errorTitle, errorMessage, steps, page, step1, step2, step3, step4, step5, step6 } =
      this.state;
    const isDisabledNext = this.checkDisbledNextButton();
    const pageIndex = page === 3 || page === 4 ? 3 : page;
    const { sStart_date, sEnd_date } = step2;
    const diffDateAssurance = sStart_date && sEnd_date ? moment(sEnd_date).diff(moment(sStart_date), "years") : "-";

    return (
      <Fragment>
        {page > 0 && page < 4 ? <StepToShowComponent steps={steps} currentPage={page} /> : ""}
        {page === 0 && <ConsentPage />}
        {page === 1 && (
          <PersonalProvider value={{ step1 }}>
            <PersonalStep1 />
          </PersonalProvider>
        )}
        {page === 2 && (
          <PersonalProvider value={{ step2, step3, diffDateAssurance }}>
            <PersonalStep2 />
          </PersonalProvider>
        )}
        {page === 3 && (
          <PersonalProvider value={{ step1, step2, step3 }}>
            <PersonalStep3 />
          </PersonalProvider>
        )}
        {page === 4 && (
          <PersonalProvider value={{ step1, step2, step3, step4 }}>
            <PersonalStep4 />
            <div className="graphic">
              <img src={DecoratedGraphic} className="graphic-img" alt="span image" />
              {/* <div className="form-wrapper footer">
                <a
                  href=""
                  className="pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    this.onNavigate(page - 1);
                    return;
                  }}
                >
                  ย้อนกลับ
                </a>
              </div> */}
            </div>
          </PersonalProvider>
        )}
        {page === 5 && (
          <PersonalProvider value={{ step1, step2, step3, step4, step5 }}>
            <PersonalStep5 />
          </PersonalProvider>
        )}
        {page === 6 && (
          <PersonalProvider value={{ step6 }}>
            <PersonalStep6 />
          </PersonalProvider>
        )}
        {page === 0 && (
          <>
            <button
              className="form-control btn-primary floating-buy"
              disabled={isDisabledNext}
              onClick={() => this.onNavigate(page + 1)}
            >
              ซื้อประกัน
            </button>
          </>
        )}
        {page > 0 && page < 4 && (
          <div className="form-wrapper d-flex mt-0 mb-5">
            <button className="form-control" onClick={() => this.onNavigate(page - 1)}>
              ย้อนกลับ
            </button>
            <SpaceBox w="12px" />
            <button
              className="form-control btn-primary"
              disabled={isDisabledNext}
              onClick={() => this.onNavigate(page + 1)}
            >
              ถัดไป
            </button>
          </div>
        )}
        {/* {page === 6 && (
          <div className="form-wrapper">
            <div className="align-item-center d-flex ml-5 mr-5">
              <button
                className="form-control btn-primary"
                disabled={isDisabledNext}
                onClick={() => this.onNavigate(1)}
              >
                ส่งข้อมูล
              </button>
            </div>
          </div>
        )} */}
        <PaymentErrorModalComponent
          show={showErroModal}
          title={errorTitle}
          message={errorMessage}
          hideModal={() => this.setState({ ...this.state, showErroModal: false })}
        />
      </Fragment>
    );
  }
}

export default withRouter(PersonalPage);
